var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMicrowave(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.5714 3.57141H1.42852C1.23908 3.57141 1.0574 3.64667 0.923443 3.78062C0.789488 3.91458 0.714233 4.09626 0.714233 4.2857V15.7143C0.714233 15.9037 0.789488 16.0854 0.923443 16.2193C1.0574 16.3533 1.23908 16.4286 1.42852 16.4286H18.5714C18.7608 16.4286 18.9425 16.3533 19.0765 16.2193C19.2104 16.0854 19.2857 15.9037 19.2857 15.7143V4.2857C19.2857 4.09626 19.2104 3.91458 19.0765 3.78062C18.9425 3.64667 18.7608 3.57141 18.5714 3.57141Z",
    stroke: "#101828",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.7143 7.14281H16.4286M15.7143 9.99996H16.4286M12.1428 6.42853H4.2857C4.09626 6.42853 3.91458 6.50378 3.78062 6.63774C3.64667 6.77169 3.57141 6.95337 3.57141 7.14281V12.8571C3.57141 13.0465 3.64667 13.2282 3.78062 13.3622C3.91458 13.4961 4.09626 13.5714 4.2857 13.5714H12.1428C12.3323 13.5714 12.514 13.4961 12.6479 13.3622C12.7819 13.2282 12.8571 13.0465 12.8571 12.8571V7.14281C12.8571 6.95337 12.7819 6.77169 12.6479 6.63774C12.514 6.50378 12.3323 6.42853 12.1428 6.42853Z",
    stroke: "#101828",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMicrowave);
export default __webpack_public_path__ + "static/media/microwave.9e545fce20499a2bd1edd2be1e4b2523.svg";
export { ForwardRef as ReactComponent };